import { render, staticRenderFns } from "./BoxSeam.vue?vue&type=template&id=aa162216&"
import script from "./BoxSeam.vue?vue&type=script&lang=js&"
export * from "./BoxSeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports